import React from 'react';
import { FaRocket } from 'react-icons/fa';
import { motion } from 'framer-motion';

export default function FloatingAction() {
    return (
        <div className="fixed bottom-8 right-8 z-50">
            <motion.div
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: 3 }}
                className="bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full p-4 shadow-2xl cursor-pointer hover:scale-110 transition-transform duration-300"
            >
                <FaRocket className="text-white text-xl" />
            </motion.div>
        </div>
    );
}
